const hu = {
  common: {
    wallet: "pénztárca",
    playPage: "játék",
    minTop: "minimális összeg $10",
    maxTop: "maximális összeg $500",
    website: "weboldal",
    signOut: "kijelentkezés",
    hidden: "rejtett",
    victory: "győzelem",
    wentWrong: "valami hiba történt, átirányítás",
    stakeLabel: "tét",
    howDoes: "hogy működik ez?",
    continue: "Folytat",
    continueWithGoogle: "Folytatás Google fiókkal",
    continueWithApple: "Folytatás Apple fiókkal",
    termsOfService: "szolgáltatási feltételek",
    privacyPolicy: "adatvédelmi irányelvek",
    termsOfServiceFooter: "szolgáltatási feltételek",
    privacyPolicyFooter: "adatvédelmi irányelvek",
    verificationCode: "igazoló kód",
    verify: "igazol",
    account: "fiók",
    error: "hiba történt\n",
    checkBackLater: "nézzen vissza később",
    looking: "keresés...",
    yes: "igen",
    no: "nem",
    pleaseSelect: "Kérjük válasszon\n",
    disclaimer: "a folytatással elfogadja a következőket:\n",
    and: "és",
  },
  endOfGame: {
    wonByCheckmate: "győzelem mattal",
    lostOnTime: "idő miatt vesztett",
    resigns: "feladja",
    gameDrawnByAgreement: "egyezség miatt döntetlen",
    abandonedTheGame: "elhagyta a játékot",
    gameAborted: "játék megszakítva",
    gameDrawnByStalemate: "döntetlen pat miatt",
    gameDrawnByFiftyMoveRule: "döntetlen a 50 lépés szabály miatt",
    gameDrawnByInsufficientMaterial: "döntetlen nem elegendő figura miatt",
    gameDrawnByThreefoldRepetition: "döntetlen háromszori ismétlés miatt",
    draw: "döntetlen",
    victory: "győzelem",
    defeat: "vereség",
    aborted: "megszakítva",
    white: "fehér",
    black: "fekete",
    inspectBoard: "tábla megtekintése",
    returnToEndOfGameModal: "folytatás",
  },
  byPhone:{
    continueOnPhone: "folytatás telefonon\n",
    or: "vagy",
    continueOnWeb: "folytatás a böngészőben\n",
    disclaimer: "alkalmas, ha az személyi igazolványáról képe van a gépén"
  },
  signUp: {
    email: "email",
    username: "felhasználónév",
    usernameInvalid: "érvénytelen felhasználónév",
    emailInvalid: "érvénytelen email",
    login: "bejelentkezés",
    continueWithPhone: "folytatás telefonszámmal",
    tickBoxes: "pipáljuk be a\nnégyzeteket",
    confirm: "Megerősítem, hogy\n",
    resideIn: "Én lakom\n",
    notPEP: "Nem vagyok politikailag exponált személy (PEP), sem PEP családtagja vagy ismerőse\n",
    purpose: "A kapcsolatom célja és természete a Gambit-al kizárólag a szolgáltatás szórakoztató célú használata\n",
    soleBenefit: "Kizárólag saját használatra fogom használni a szolgáltatást, és nincs más előnyben részesített tulajdonos\n",
  },
  identity: {
    beingVerified: "azonosság\nellenőrzése folyamatban",
    verified: "azonosság\nellenőrizve",
    failed: "azonosság ellenőrzése\nsikertelen",
  },
  payment: {
    failed: "fizetés sikertelen.\nkérjük próbálja újra",
    successful: "fizetés\nsikeres!",
    toppedUp: "feltöltve!",
    topUp: "feltöltés\n",
    payWith: "fizetés...\n",
  },
  gameplay: {
    play: "játék\n",
    challenge: "kihívást küldött",
    gameWorth: "játék értéke\n",
    whatsYourNumber: "mi a\nszámod?",
    receiveCode: "rövidesen kapni fog egy igazoló\nkódot",
    matchedOpponent: "Hasonló értékű ellenfél lesz keresve.",
    stake: {
      total: "A teljes tét az alább kiválasztott összeg lesz.",
      contribution: "Ebből az összegből nagyjából a felét fogja fizetni.",
      weakerOpponent: "Ha gyengébb ellenfelet talál, nagyobb részét fogja fizetni a tétnek.",
      strongerOpponent: "Ha erősebb ellenfelet talál, kisebb részét fogja fizetni a tétnek.",
    },
    supportInfo: "További információért látogasson el a támogatási oldalunkra.\n",
    continueBrowser: "folytatás a böngészőben\n",
    continuePhone: "folytatás telefonon\n",
    getStarted: "kezdjük\n",
    sentText: "küldtünk egy\nszöveget",
    enterReceivedCode: "adja meg a kapott\nigazoló kódot",
    wrongCode: "hibás kód, próbálja újra\n",
    secPerMove: "mp/lépés",
    resign: {
      prompt: "biztosan feladja a játékot?",
    },
    draw: {
      offer: "elfogadja a döntetlen ajánlatot?",
    },
    rating: "értékelés\n",
    balance: "egyenleg\n",
    rematch: "visszavágó\n",
    newOpponent: "új ellenfél\n",
    home: "kezdőlap\n",
    rematchOffer: "az ellenfele visszavágót ajánl. elfogadja?",
    leaveGame: "Jelenleg egy játékban van. Biztosan ki akar lépni?",
    room: "szoba:\n",
    gameTypes: {
      bullet: {
        title: "bullet\n",
        description: "Adrenalin sakk. Önnek és az ellenfelének csak 1 percük van a játék megnyerésére.",
      },
      blitz: {
        title: "blitz\n",
        description: "Önnek és az ellenfelének 3 percük van a játék megnyerésére.",
      },
    },
    stakes: {
      unlockNext: "játsszon még {amount} játékot a következő tét feloldásához",
      allUnlocked: "minden tét feloldva",
    },
    withdraw: "pénzfelvétel\n",
  },
  puzzle: {
    begin: "kezdeni",
    next: "következő",
    unavailableInYourRegion: "nem elérhető",
    puzzle: "rejtvény",
    whiteToPlay: "fehér lép",
    blackToPlay: "fekete lép",
    time: "idő",
    solution: "megoldás",
    somethingWentWrong: "valami hiba történt",
    rating: "értékelés",
    credits: "kreditek",
    puzzleFailed: "vereség",
    puzzleSolved: "győzelem",
    correct: "helyes megoldás",
    incorrect: "helytelen megoldás",
    youRanOutOfTime: "lejárt az időd",
    puzzleDescription: "10 másodperced van + 2 másodperc/mozgás egy rejtvény megoldására.",
    creditsLeft: "maradó kredit",
    refillIn: "újratöltés",
    lastPuzzle: "ez az utolsó rejtvényed, nézd vissza később továbbiakért.",
    outOfCredits: "elfogytak a kreditjeid, nézd vissza később.",
    locationPrompt: "Szükségünk van a helyedre a folytatáshoz. Ha le van tiltva, kérlek, engedélyezd újra:",
    locationInstructions: "Kattints a címsorban lévő ikonra, válaszd az 'Mindig engedélyezni' lehetőséget, és frissítsd az oldalt",
    creditsError: "Hiba a kreditek betöltésekor",
    moves: "Lépések:",
  },
};

export {hu};